import { useEffect } from 'react'
import PendingComponent from '@/components/pending-component'
import { deleteToken } from '@/lib/auth'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { useServerFn } from '@tanstack/react-start'
import { toast } from 'sonner'

export const Route = createFileRoute('/sign-out')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (!user) {
      throw redirect({ to: '/sign-in' })
    }
  }
})

function RouteComponent() {
  const { orpc, queryClient } = Route.useRouteContext()
  const navigate = Route.useNavigate()
  const router = useRouter()

  const deleteTokenFn = useServerFn(deleteToken)

  const signOut = useMutation(
    orpc.backoffice.auth.signOut.mutationOptions({
      retry: false,
      onSuccess: async () => {
        await deleteTokenFn()
        localStorage.removeItem('__auth_token')
        queryClient.clear()
        router.invalidate()
      },
      onError: (error) => {
        if (error.message.toLowerCase().includes('unauthorized')) {
          return
        }
        toast.error(`Sign out failed: ${error.message}`)
        navigate({ to: '/dashboard' })
      }
    })
  )

  useEffect(() => {
    const timeout = setTimeout(() => {
      signOut.mutate({})
    }, 500)
    return () => clearTimeout(timeout)
  }, [signOut])

  return <PendingComponent />
}
